import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Viewport from './Viewport';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Sidebar />
        <Viewport />
      </div>
    );
  }
}

export default App;
